export default "__VITE_ASSET__h1gp53Fz__"